module.exports = __webpack_public_path__ + "img/SyncNewChanges.a6e0bec2.gif";